import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { delPdtWishList, loadPdtWishList, savePdtWishList } from '@app/actions/shoppingmall/wishlist-pdt.action';
import { setWAlert } from '@app/actions/w-alert.action';
import { ActionConstant } from '@app/common/constant/action-constant';
import { CommonConstant } from '@app/common/constant/common.constant';
import { MemberConstants } from '@app/common/constant/member.constant';
import { MessageConstant } from '@app/common/constant/message.constant';
import { MyProgramConstant } from '@app/common/constant/my-program.constant';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { AuthUtil } from '@app/common/util/auth.util';
import { CommonUtils } from '@app/common/util/common.util';
import { ConvertUtil } from '@app/common/util/convert.util';
import { ParameterUtils } from '@app/common/util/parameter.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { OrderMstModel } from '@app/models/myoffice/order/order-mst.model';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { MemberModel } from '@app/models/system/member.model';
import { SmPayHeaderModel } from '@app/models/system/sm-pay-header.model';
import { SmWownetPgModel } from '@app/models/system/sm-wownet-pg.model';
import { SmWownetModel } from '@app/models/system/sm-wownet.model';
import { WownetWordModel } from '@app/models/system/wownet-word.model';
import { CartState, getCartInfo } from '@app/selectors/shoppingmall/cart.selector';
import { PdtWishListState, getPdtWishList } from '@app/selectors/shoppingmall/wishlist-pdt-selector';
import { getFindPayHeader, getSmWownet, getSmWownetPg, getWowWord, SmWownetState } from '@app/selectors/system/sm-wownet.selector';
import { WAlertState } from '@app/selectors/w-alert.selector';
import { CartService } from '@app/services/shoppingmall/cart.service';
import { environment } from '@enviroments/environment';
import { Store } from '@ngrx/store';
import { PaginationInstance } from 'ngx-pagination';
import { Observable } from 'rxjs';

declare const getYnPayHeader: any;

@Component({
  selector: 'products2',
  templateUrl: './products2.component.html',
  styleUrls: ['./products2.component.css']
})
export class Products2Component implements OnInit, OnDestroy, OnChanges {
  @Input()
  config: PaginationInstance = {
    id: "products",
    currentPage: 0,
    itemsPerPage: 8,
    totalItems: 0,
  }

  @Input()
  products: OrdPdtModel[] = [];

  @Input()
  urlWownet: string = "";

  @Input()
  sortCd : string = "";

  @Input()
  cateCd : string = "";

  smPayHeader$ = new Observable<SmPayHeaderModel>();

  smWowWord$ = new Observable<WownetWordModel>();
  smWowWord: any = {} as WownetWordModel;
  
  smWownet$ = new Observable<SmWownetModel>();
  smWownet: any = {} as SmWownetModel;

  smWownetPg$ = new Observable<SmWownetPgModel>();
  smWownetPg: any = {} as SmWownetPgModel;

  cartInfo$ = new Observable<OrderMstModel[]>();
  cartInfo: OrderMstModel[] = {} as OrderMstModel[];

  wishList$ = new Observable<OrdPdtModel[]>();
  wishList : OrdPdtModel[] = {} as OrdPdtModel[];

  member = AuthUtil.getLoginedInfo();

  quantities: number[] = [];
  
  plus: string = "+";
  minus: string = "-";
  today: string = "";
  sort: string = '';
  linkGuest: string = CommonConstant.NO;
  wishYN: string[] = [];
  urlHomePage = CommonConstant.SLASH;
  currentUrl : String = '';

  isLogin: boolean = AuthUtil.isLogined();
  isPv1: boolean = false;
  isPv2: boolean = false;
  isPv3: boolean = false;
  isRetailAmt: boolean = false;
  isAmt: boolean = false;
  isOrd: boolean = false;
  isPoint: boolean = false;
  isConsumer:boolean = false;
  loginInfo: MemberModel | null = null;
  GRP_AREKHAN = environment.comCd + MemberConstants.GRP_AREKHAN;

  constructor(private _router : Router,
              private _wAlertStore: Store<WAlertState>,
              private _wishListStore: Store<PdtWishListState>,
              private _cartService: CartService,
              private _cartStore: Store<CartState>,
              private _smWownetStateStore: Store<SmWownetState>,) {
    this.cartInfo$ = this._cartStore.select(getCartInfo);
    this.smWownetPg$ = this._smWownetStateStore.select(getSmWownetPg);
    this.smWownet$ = this._smWownetStateStore.select(getSmWownet);
    this.smWowWord$ = this._smWownetStateStore.select(getWowWord);
    this.smPayHeader$ = this._smWownetStateStore.select(getFindPayHeader);
    this.wishList$ = this._wishListStore.select(getPdtWishList);
  }

  ngOnDestroy(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    let productsChange = changes['products'];
    if(ValidationUtil.isNotNullAndNotEmpty(productsChange)) {
      if(ValidationUtil.isNotNullAndNotEmpty(this.products)) {
        let length = this.products.length;
        this.quantities = new Array(length);
        this.wishYN = new Array(length);
        for(let i = 0; i < length; i++) {
          this.quantities[i] = 1;
          this.wishYN[i] = ConvertUtil.convertToString(this.products[i].wishYN);
        }
      } 
    }
  }

  ngOnInit(): void {
    this.currentUrl = this._router.url;
    let linkG = sessionStorage.getItem(CommonConstant.LINK_GUEST);
    this.linkGuest = ConvertUtil.convertToString(linkG);
    this.isConsumer = CommonUtils.isConsumer();

    if(this.isLogin){   
      this.loginInfo = AuthUtil.getLoginedInfo();
    }

    this.initData(this.smPayHeader$, this.smWowWord$, this.smWownet$, this.smWownetPg$);

    this.cartInfo$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.cartInfo = res;
      }
    });

    this.wishList$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.wishList = res;
      }
    });
  }

  showAlertRequiredLogin(): void {
    this._wAlertStore.dispatch(
      setWAlert({ 
        wAlert: { 
          icon: WAlertConstant.confirm, 
          message: MessageConstant.msgRequiredLogin, 
          action: ActionConstant.actionConfirmLogined 
        } 
      })
    );
  }

  handleOnClickProductDetail(item: OrdPdtModel): void {
    if(ValidationUtil.isNotNullAndNotEmpty(item.pdtCd)) {
      if(this.smWownet.lShowPdtYn !== CommonConstant.YES && !this.isLogin) {
        this.showAlertRequiredLogin();
      } else {
        let tmp: any = [];
        let pdtClickRecent: any = localStorage.getItem(CommonConstant.PRODUCT_RECENT);
        if(ValidationUtil.isNotNullAndNotEmpty(pdtClickRecent)) {
          tmp = JSON.parse(pdtClickRecent);
          let count = tmp.filter((e : any) => e.pdtCd == item.pdtCd);
          if(count.length == 0) {
            if(tmp.length == 8) {
              tmp.splice(0,1);
            }
            tmp.push(item);
          }
        } else {
          tmp.push(item);
        }
        localStorage.setItem(CommonConstant.PRODUCT_RECENT, JSON.stringify(tmp));
        window.dispatchEvent(new Event('storage'));

        this._router.navigate([MyProgramConstant.urlShopping + `/product/${item.pdtCd}`]);
      }
    }
  }

  handleOnclickAddWishList(item: any, index: any):void {
    if(!this.isLogin) {
      this.showAlertRequiredLogin();
    } else {
      let userId = '';
      if(this.member) {
        userId = ConvertUtil.convertToString(this.member.userid);
      }

      if(ValidationUtil.isNotNullAndNotEmpty(this.wishList)) {
        if(this.wishList.filter(v => v.pdtCd === item.pdtCd).length === 0) {
          this.wishYN[index] = CommonConstant.YES;
          this._wishListStore.dispatch(savePdtWishList({userid: userId, pdtCd: item.pdtCd}));
          this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.successful, message: MessageConstant.MSG_ADD_WISH_ITEM_SUCCESS } }));
        } else {
          this.wishYN[index] = CommonConstant.NO;
          this._wishListStore.dispatch(delPdtWishList({userid: userId, pdtCd: item.pdtCd}));
          this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.successful, message: MessageConstant.MSG_DELETE_WISH_ITEM_SUCCESS } }));
        }     
      } else {
        this.wishYN[index] = CommonConstant.YES;
        this._wishListStore.dispatch(savePdtWishList({userid: userId, pdtCd: item.pdtCd}));
        this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.successful, message: MessageConstant.MSG_ADD_WISH_ITEM_SUCCESS } }));
      }
      this._wishListStore.dispatch(loadPdtWishList({params : ParameterUtils.getPdtWishListParams("", "", 100, 0,  "PC")}));
    }
  }

  handleOnAddToCart(index: number): void {
    if(index >= 0 && index < this.quantities.length && index < this.products.length) {
      let item = this.products[index];
      let quantity = this.quantities[index];

      if(this.isLogin) { 
        this._cartService.addCartItemLogin(item, quantity, this.cartInfo);
      } else {
        this._cartService.addCartItemNotLogin(item, quantity);
      }
    } 
  }

  initData(smPayHeader$ : Observable<SmPayHeaderModel>, 
           smWowWord$ : Observable<WownetWordModel>, 
           smWownet$ : Observable<SmWownetModel>, 
           smWownetPg$ : Observable<SmWownetPgModel>) {
    smPayHeader$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.isPv1 = getYnPayHeader(res, CommonConstant.PV1);
        this.isPv2 = getYnPayHeader(res, CommonConstant.PV2);
        this.isPv3 = getYnPayHeader(res, CommonConstant.PV3);
      }
    });

    smWownet$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.smWownet = res;
        this.isAmt = res.lShowAmtYn === CommonConstant.YES;
        this.isRetailAmt = res.lShowRetailYn === CommonConstant.YES;
        this.isOrd = res.lOrdYn === CommonConstant.YES;
      }
    });

    smWowWord$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.smWowWord = res;
      }
    });

    smWownetPg$.subscribe(res => this.isPoint = res.mpoint === CommonConstant.YES);
  }

}
